export interface ServiceCategory {
  title: string;
  items: string[];
}

export interface ValuePillar {
  label: string;
  copy: string;
  emphasis: number;
}

export interface ContactRequest {
  fullName: string;
  email: string;
  phone: string;
  subject: string;
  message: string;
  botcheck: boolean;
}

export interface AppointmentRequest {
  fullName: string;
  email: string;
  phone: string;
  company: string;
  service: string;
  preferredDate: string;
  preferredTime: string;
  message: string;
  botcheck: boolean;
}

export const navigationItems = [
  { label: 'Home', href: '#home' },
  { label: 'Services', href: '#services' },
  { label: 'Why us', href: '#why-us' },
  { label: 'About', href: '#about' },
  { label: 'Contact', href: '#contact' },
];

export const appointmentServices = [
  'Development Services (Web, Mobile, Enterprise Systems)',
  'Public Sector & LGU Systems (Real Property Tax, BPLS, Smart Governance)',
  'Healthcare & EMR Systems (Hospital Info, PhilHealth Integration)',
  'On-Demand Delivery & Fleet Logistics Platforms',
  'Web3 & Blockchain Engineering (Smart Contracts, Tokenomics, Ledger Auditing)',
  'Marketing & Brand Support (Identity, Video, 3D Modeling)',
  'Lead Generation & Sales Support (Prospecting, Appointments)',
  'Admin & Operation Support (Inbox, Calendar, Reporting)',
  'Other',
];

export const serviceCategories: ServiceCategory[] = [
  {
    title: 'Development Services, EMR, LGU & Web3 Systems',
    items: [
      'Front-end and back-end custom programming',
      'Cross-platform mobile apps for iOS and Android',
      'Web3 smart contract engineering & security ledger auditing',
      'Electronic Medical Records (EMR) & Hospital Info Systems (HIMS)',
      'LGU Real Property Tax (RPT) & Tax Declaration portals',
      'Smart LGU Business Permit & Licensing Systems (BPLS)',
      'On-demand express delivery & dispatch fleet mobility platforms',
      'Enterprise system integration, security auditing & SLA maintenance',
    ],
  },
  {
    title: 'Marketing & Brand Support',
    items: [
      'Brand identity, logo and graphic design',
      'Video production and animated explainer assets',
      '3D architectural modeling',
      'Social media support and community management',
      'CRM updates and campaign assistance',
    ],
  },
  {
    title: 'Lead Generation & Sales Support',
    items: [
      'Targeted B2B executive prospecting',
      'Outbound lead qualification & cold calling',
      'C-level appointment setting campaigns',
      'Pipeline tracking and executive CRM logging',
    ],
  },
  {
    title: 'Admin & Operation Support',
    items: [
      'Executive calendar & schedule management',
      'Inbox oversight & SLA response tracking',
      'Operations reporting & administrative documentation',
    ],
  },
];

export const valuePillars: ValuePillar[] = [
  {
    label: 'ROI First',
    copy: 'Decisions tied to measurable business value.',
    emphasis: 86,
  },
  {
    label: 'Smart Costing',
    copy: 'Practical scope, technology, and delivery choices.',
    emphasis: 72,
  },
  {
    label: 'Long-Term',
    copy: 'Systems that stay maintainable as you grow.',
    emphasis: 80,
  },
  {
    label: 'Innovation',
    copy: 'Useful ideas applied to real operational needs.',
    emphasis: 84,
  },
];
